<div class="flex gap-1 align-items-center">
  <div
    class="avatar"
    [style.backgroundColor]="avatarColor"
    [style.color]="fontColor"
  >
    <p>{{ initials }}</p>
  </div>
  <div class="text-sm font-semibold">{{ name | titlecase }}</div>
</div>
